import { globalStyles } from '@client/shared/constants';

const style = {
  gridHeader: {
    backgroundColor: "#E0E3E7!important",
    color: '#000!important',
  },
  gridPaper: {
    backgroundColor: "grey.50"
  },
};

export default style;